import { render, staticRenderFns } from "./EditSeguroicontratarPage.vue?vue&type=template&id=66d1b66d"
import script from "./EditSeguroicontratarPage.vue?vue&type=script&lang=js"
export * from "./EditSeguroicontratarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports